/**
 * @file
 * Toggle sticky position to prevent inaccessible content.
 */

(function ($, Drupal) {
  Drupal.behaviors.sticky = {
    attach: function attach(context) {
      const stickyElements = once('sticky', '[data-sticky]', context);

      // Toggle element position initially...
      stickyElements.forEach((el) => togglePosition(el));

      // ...and when window size changes (debouncing).
      let windowResizeDebounceTimeout = false;
      window.addEventListener('resize', function () {
        clearTimeout(windowResizeDebounceTimeout);
        windowResizeDebounceTimeout = setTimeout(function () {
          stickyElements.forEach((el) => togglePosition(el));
        }, 250);
      });
    },
  };

  /**
   * Toggle element position between sticky and relative based on viewport height.
   * @param element
   */
  function togglePosition(element) {
    const isSmallerThanViewportHeight =
      element.offsetHeight > document.documentElement.clientHeight;
    if (isSmallerThanViewportHeight) {
      // Keep current offset to parent container.
      const parentStyle = window.getComputedStyle(element.parentElement, null);
      const parentInnerHeight = parseFloat(
        parentStyle.getPropertyValue('height'),
      );
      if (element.offsetTop <= parentInnerHeight - element.offsetHeight) {
        element.style.top = element.offsetTop + 'px';
      }
      else {
        element.style.top = '0px';
      }
      element.style.position = 'relative';
    } else {
      element.style.top = '';
      element.style.position = 'sticky';
    }
  }
})(jQuery, Drupal);
